import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import UserAvatar from 'components/shared/user/UserAvatar';
import StyledMonthlySessionEventContainer from 'common/theme/calendar/event/month/StyledMonthlySessionEventContainer';
import StyledMonthlySessionEventIndicator from 'common/theme/calendar/event/month/StyledMonthlySessionEventIndicator';
import StyledMonthlySessionEventText from 'common/theme/calendar/event/month/StyledMonthlySessionEventText';
import { isPastSession, dimIfPastSx } from 'common/utils/sessionColor';

// Hora compacta de inicio ("7am", "12pm") para identificar la sesión en el mes.
const startLabel = (d) => {
  try { const h = new Date(d).getHours(); return `${(h % 12) || 12}${h < 12 ? 'am' : 'pm'}`; } catch { return ''; }
};

function GroupSessionEvent({ event }) {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.up('md'));
  const { extendedProps } = event;
  const { trainer, sessionTypeName, status } = extendedProps;
  const displayUser = trainer ?? { full_name: 'Active Plus' };
  // En el mes priorizamos el distintivo "Active Plus"; si el tipo ya es "active plus" (o no hay), no se duplica.
  const showType = sessionTypeName && !sessionTypeName.trim().toLowerCase().startsWith('active plus');
  const category = showType ? `Active Plus · ${sessionTypeName}` : 'Active Plus';
  const time = event.start ? startLabel(event.start) : '';
  const past = isPastSession(event.start, event.end);

  return (
    <StyledMonthlySessionEventContainer sx={dimIfPastSx(past)}>
      <StyledMonthlySessionEventIndicator status={status ?? 'SCHEDULED'} />
      <UserAvatar size={isMedium ? 30 : 24} textSize={isMedium ? 15 : 12} user={displayUser} />
      <StyledMonthlySessionEventText variant="body2" sx={{ color: '#F9BD4E', fontWeight: 600 }}>
        {time ? `${category} · ${time}` : category}
      </StyledMonthlySessionEventText>
    </StyledMonthlySessionEventContainer>
  );
}

GroupSessionEvent.propTypes = {
  event: PropTypes.object.isRequired
};

export default GroupSessionEvent;
